import React, { useEffect } from "react";
import ProjectItem from "../components/ProjectItem";
import { ProjectList } from "../helpers/ProjectList";

import "../styles/Projects.css";

function Projects() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="projects">
      <div className="projectList">
        {ProjectList.map((project, idx) => {
          return (
            <ProjectItem 
              key={idx}
              id={idx} 
              name={project.name}
              type={project.type}
              image={project.image}
              description={project.description}
              skills={project.skills}
              githubUrl={project.githubUrl}
              websiteUrl={project.websiteUrl}
              animationDelay={idx * 0.1}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Projects;
